import React from 'react';
import jet from "@randajan/jet-core";

import "./Review.scss";
import { Link } from '@randajan/jet-react/dom/link';
import { usePop } from '@randajan/jet-react/dom/modal';
import { Block } from '@randajan/jet-react/dom/block';
import { BlimpRating } from '../../../../elements/Graphs/BlimpRating/BlimpRating';
import { Ratio } from '../../../../elements/Graphs';
import { Locale } from '../../../../assets/Locale';

const shrink = (str, maxLength, suffix="")=>{
    str = String.jet.to(str);
    maxLength = Math.max(0, Number.jet.to(maxLength));
    if (!maxLength || str.length < maxLength) { return str; }
    const precut = str.substring(0, maxLength - suffix.length);
    const midword = (precut.match(/[^\S][\S]*$/) || [""])[0];
    const mwlength = midword.length;
    const cut = (mwlength > (maxLength / 4)) ? precut : precut.slice(0, -mwlength);
    return cut + suffix;
}

const ReviewFooter = props=>{
    const { name, source } = props.review;
    const say = Locale.use();
    return (
        <div className="footer">
            <div className="name">{name}</div>
            <div className="source">{source ? <Link to={source}>{say("reviewsSource")}</Link> : null}</div>
        </div>
    )
}

const ReviewHeader = props=>{
    const { className, children, review } = props;
    const { rating } = review;

    return (
        <Block className={jet.melt(["Review", className], " ")}>
            <div className="reviewHeader">
                <BlimpRating value={rating} from={0} to={5} step={0.5}/>
                <Ratio value={Math.round(rating*2)/2} total={5}/>
            </div>
            
            {children}
        </Block>
    );
}

export const ReviewFull = props=>{
    const { review } = props;
    const { reply, content } = review;
    const say = Locale.use();

    return (
        <ReviewHeader review={review}>
            <p className="reviewContent">{content}</p>
            <ReviewFooter review={review}/>
            {!reply ? null : <Block className="reply" caption={say("reviewsReply")}>
                <p className="reviewContent">{reply}</p>
            </Block>}
        </ReviewHeader>
    );
}

export const ReviewShort = props=>{

    const { maxLength } = props;

    const say = Locale.use();

    const review = (props.review || {});
    const { reply, content } = review;
    const pop = usePop();

    const stext = shrink(content, maxLength, "...");

    const showMore = (reply || content?.length > stext.length);

    return (
        <ReviewHeader review={review} className="reviewShort">
            <div className="reviewContent">{stext}</div>
            {showMore ? <a className="popup" onClick={_=>pop.up(<ReviewFull review={review}/>)}>{say("reviewsReadMore")}</a> : null}
            <ReviewFooter review={review}/>
        </ReviewHeader>
    );
}